import React, { useState } from 'react';
import { useMediaQuery } from '../../../libs';

export const FlashSalesBar = ({ activePromotion, clickFlashSale, flashSaleData }) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [visible, setIsVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className={'text-white'}
      style={{
        background: '#222',
        position: 'relative',
        maxHeight: isMobile ? '64px' : '32px',
        padding: '8px 0',
        cursor: 'pointer',
        width: '100%',
        fontSize: '14px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        gap: isMobile ? '4px' : '12px',
      }}
      onClick={clickFlashSale}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: activePromotion?.bgColor,
          }}
        >
          <i className={`svg-i ${activePromotion.iconName}`} style={{ position: 'relative', fontStyle: 'normal', width: '16px', height: '16px' }}></i>
        </span>
        <div className={'font-medium'}>{activePromotion?.name}</div>
      </div>
      <div style={{ width: '1px', background: '#3D3F4B', height: '16px', display: isMobile ? 'none' : 'block' }}></div>
      <div className={'font-medium'} style={{ display: 'flex', alignItems: 'center' }}>
        მიიღე {flashSaleData.discount_value}%-იანი ფასდაკლება{' '}
        <i className={'svg-i arrow-forward'} style={{ display: isMobile ? 'inline-block' : 'none', marginLeft: '4px' }} />
      </div>
      <span className={'font-base'} style={{ textDecoration: 'underline', fontSize: '12px', color: '#d4d4d7', display: isMobile ? 'none' : 'block' }}>
        გაიგე მეტი
      </span>
      <i
        className={'svg-i flash-sale-bar-close'}
        onClick={(e) => {
          e.stopPropagation();
          sessionStorage.setItem('FlashSalesBarClosed', 'true');
          setIsVisible(false);
        }}
        style={{ position: 'absolute', right: '24px', top: '50%', transform: 'translateY(-50%)' }}
      ></i>
    </div>
  );
};
